
export default {
  name: 'AddJobRolesSvg',
};
